var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-show"},[_c('label',{style:({
      minWidth: _vm.minWidth ? `${_vm.minWidth}px` : null,
      maxWidth: _vm.maxWidth ? `${_vm.maxWidth}px` : null,
    })},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"data-show-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }